import axios from './Axios';
import { getAxiosHeader, urlServicesRelease } from './AxiosVars';

export function getScannerHist4IdCar(idCar) {
    const url = urlServicesRelease + '/cars/v4/scanner/idCar/' + idCar;
    return axios({
        title: 'Abfragen der Historie',
        method: 'get',
        url: url,
        headers: getAxiosHeader(),
    });
}

export function getScannerHist4Barcode(barcode) {
    const url = urlServicesRelease + '/cars/v4/scanner/barcode/' + barcode;
    return axios({
        title: 'Abfragen der Historie',
        method: 'get',
        url: url,
        headers: getAxiosHeader(),
    });
}

export function saveScannerEvent(strData) {
    const url = urlServicesRelease + '/cars/v4/scanner/';
    return axios({
        title: 'Speichern des Ereignisses',
        method: 'post',
        url: url,
        data: strData,
        headers: getAxiosHeader(),
    });
}
